import type { LayerSpecification, SourceSpecification, StyleSpecification } from 'maplibre-gl';

/** The sources and layers one feature contributes to the map style. */
export interface StylePart {
  sources?: Record<string, SourceSpecification>;
  layers?: LayerSpecification[];
  /** Icon sprite sheet; the style can only have one, so at most one part should set it. */
  sprite?: string;
}

/** Merges feature style parts; layer order follows the order of `parts` (first = bottom). */
export function composeStyle(glyphs: string, parts: StylePart[]): StyleSpecification {
  const sprite = parts.find((p) => p.sprite)?.sprite;
  return {
    version: 8,
    glyphs,
    ...(sprite && { sprite }),
    sources: Object.assign({}, ...parts.map((p) => p.sources)),
    layers: parts.flatMap((p) => p.layers ?? []),
  };
}
